var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKakao = function SvgKakao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FAE300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C1E1E",
    d: "M30 17c2.532 0 4.873.495 7.024 1.486 2.15.99 3.851 2.337 5.101 4.04C43.375 24.23 44 26.087 44 28.1c0 2.013-.625 3.873-1.875 5.582-1.25 1.708-2.947 3.058-5.093 4.048-2.146.99-4.49 1.485-7.032 1.485-.802 0-1.63-.057-2.484-.173-3.709 2.59-5.683 3.9-5.922 3.93a.398.398 0 0 1-.328-.015.289.289 0 0 1-.094-.126.392.392 0 0 1-.031-.141v-.063c.062-.409.536-2.112 1.421-5.11-2.01-1.006-3.607-2.34-4.789-4C16.592 31.854 16 30.049 16 28.099c0-1.95.625-3.87 1.875-5.573 1.25-1.703 2.95-3.05 5.102-4.04C25.127 17.496 27.469 17 30 17"
  })));
};
export default SvgKakao;